import React from "react";
import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { useT } from "../../context/LanguageContext";

export const Footer = () => {
  const { t } = useT();
  return (
    <footer className="border-t border-gray-200 bg-white/60">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
          <div className="flex items-center gap-2">
            <span className="w-8 h-8 rounded-lg bg-green-800 text-white flex items-center justify-center">
              <Sparkles className="w-4 h-4" />
            </span>
            <span className="font-display font-bold text-lg tracking-tight">Tasklio AI</span>
          </div>
          <div className="flex flex-wrap items-center gap-6 text-sm text-gray-500">
            <Link to="/" className="hover:text-gray-900" data-testid="footer-home-link">{t("footer.home")}</Link>
            <Link to="/pricing" className="hover:text-gray-900" data-testid="footer-pricing-link">{t("footer.pricing")}</Link>
            <Link to="/login" className="hover:text-gray-900" data-testid="footer-login-link">{t("footer.login")}</Link>
            <Link to="/register" className="hover:text-gray-900" data-testid="footer-signup-link">{t("footer.signup")}</Link>
            <Link to="/privacy" className="hover:text-gray-900" data-testid="footer-privacy-link">{t("footer.privacy")}</Link>
            <Link to="/terms" className="hover:text-gray-900" data-testid="footer-terms-link">{t("footer.terms")}</Link>
            <Link to="/terms#sms-terms" className="hover:text-gray-900" data-testid="footer-sms-terms-link">{t("footer.smsTerms")}</Link>
            <Link to="/sms-opt-in" className="hover:text-gray-900" data-testid="footer-sms-opt-in-link">{t("footer.smsOptIn")}</Link>
            <a
              href="mailto:support@tasklio.co"
              className="hover:text-gray-900"
              data-testid="footer-support-link"
            >
              {t("footer.support")}
            </a>
          </div>
          <p className="text-sm text-gray-400">{t("footer.copyright", new Date().getFullYear())}</p>
        </div>
      </div>
    </footer>
  );
};
